import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProcessingRules } from '@app/services/bavel-payment-manager-client.service';

@Component({
  selector: 'app-payment-detail-processing-rules',
  templateUrl: './payment-detail-processing-rules.component.html',
  styleUrls: ['./payment-detail-processing-rules.component.scss'],
  standalone: false
})
export class PaymentDetailProcessingRulesComponent {
  @Input() public processingRules: ProcessingRules = {} as ProcessingRules;
  @Output() public processingRulesChange: EventEmitter<ProcessingRules> = new EventEmitter();
}
